import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { MCard, MSpinner } from "components/Shared";
import CustomerSurveyTypeConfiguration from "components/Customer/Profile/SurveyTypes/CustomerSurveyTypeConfiguration";
import { CustomerDetailsDto, SurveyTypeListDto } from "interfaces/Mueller.Business.Models.ts";
import CustomerSurveyTypeForms from "./CustomerSurveyTypeForms.tsx";
import CustomerSurveyTypeNotifications from "./CustomerSurveyTypeNotifications.tsx";
import { Grid } from "react-md";
import { updateHeader, clearHeader } from "actions/layout";
import CustomerSurveyTypeStamps from "components/Customer/SurveyTypes/CustomerSurveyTypeStamps.tsx";
import CustomerExperienceAssignment from "../CustomerExperienceAssignment.tsx";
import PhoenixFormPreview from "components/PhoenixFormsV4/PhoenixFormsDesigner/PhoenixFormPreview.tsx";

interface CustomerSurveyTypeDetailsProps {
  verticalDisplay: boolean;
  // Redux
  selectedSurveyType: SurveyTypeListDto;
  customerDetails: CustomerDetailsDto;
  updateHeader: (headerDefinitions: any) => void;
  clearHeader: () => void;
  // Router
  history: any;
}

export interface PnxFormMetaData {
  formName: string,
  formId: string
}

const  CustomerSurveyTypeDetails = (props: CustomerSurveyTypeDetailsProps) => {
  
  if (!props.selectedSurveyType || !props.customerDetails) {
    return (<MSpinner />);
  }

  const [selectedPnxFormInfo, setSelectedPnxFormInfo] = useState<PnxFormMetaData | null>(null);

  useEffect(() => {
    if (!props.verticalDisplay) {
      props.updateHeader({
        buttons: [{
            name: "Return to Survey Types",
            onClick: () =>  props.history.push({ pathname: "/customer/survey-types" })
          }]
      });
    }
    return () => {
      if (!props.verticalDisplay) {
        props.clearHeader();
      }
    };
  }, []);

  const determinePnxFormPreviewCardChildren = () => {
    
    if (!selectedPnxFormInfo){
      return <p>Please select a form to preview.</p>;
    }

    return (
      selectedPnxFormInfo.formId ?
        <PhoenixFormPreview pnxFormId={selectedPnxFormInfo.formId} />
        :
        <p>Selected form is not a Phoenix form.</p>
    );
  };

  const pnxFormPreviewCardTitle = `Phoenix Form Preview${selectedPnxFormInfo?.formName ? ` - ${selectedPnxFormInfo.formName}` : ''}`;
  const renderPnxFormPreviewInDiv = selectedPnxFormInfo !== null && selectedPnxFormInfo.formId?.length > 0; // Render children of the preview card in a div only when we're actually displaying a pnx form preview for css purposes

  return (
    <>
      <Grid>
        <CustomerSurveyTypeConfiguration
            customerNumber={props.customerDetails.number}
            surveyTypeCode={props.selectedSurveyType.code}
            verticalDisplay={props.verticalDisplay}
        />
        <CustomerExperienceAssignment 
          customerNumber={props.customerDetails.number}
          surveyTypeCode={props.selectedSurveyType.code}
          verticalDisplay={props.verticalDisplay}
        />
        <CustomerSurveyTypeStamps verticalDisplay={props.verticalDisplay} />
        <CustomerSurveyTypeForms
          verticalDisplay={props.verticalDisplay}
          setSelectedPnxFormInfo={setSelectedPnxFormInfo}
        />
        <MCard
          className="customer-survey-type-pnx-form-preview-card"
          title={pnxFormPreviewCardTitle}
          renderChildrenInDiv={renderPnxFormPreviewInDiv}
        >
          {determinePnxFormPreviewCardChildren()}
        </MCard>
        <CustomerSurveyTypeNotifications verticalDisplay={props.verticalDisplay} />
      </Grid>
    </>
  );
};

const mapStateToProps = state => ({
  selectedSurveyType: state.customer.selectedSurveyType,
  customerDetails: state.customer.customerDetails,
});

const mapDispatchToProps = (dispatch) => ({
  updateHeader(headerDefinitions) {
      dispatch(updateHeader(headerDefinitions));
  },
  clearHeader() {
      dispatch(clearHeader());
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerSurveyTypeDetails));